
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import CountdownTimer from '~/components/Promotions/CountdownTimer.vue';
import AuthActions from '~/mixins/AuthActions';

interface ICta {
  text: string;
  url: string;
}

@Component({
  components: {
    CountdownTimer,
  },
})
export default class ImageWithTextRow extends Mixins(AuthActions) {
  @Prop({ type: String, default: 'section' })
  readonly tag!: string;
  @Prop({ type: String, default: 'primary' })
  readonly bgColor!: 'primary' | 'secondary' | 'tertiary';
  @Prop([Array, String]) readonly headerText!: string | string[];
  @Prop([Array, String]) readonly bodyText!: string | string[];
  @Prop(Object) readonly ctaPrimary!: ICta;
  @Prop(Object) readonly ctaSecondary!: ICta;
  @Prop({ type: String, default: '' }) readonly imageAlt!: string;
  @Prop(String) readonly imageUrl!: string;
  @Prop([Number, String]) readonly imageWidth!: number | string;

  @Prop(Boolean) readonly isHeroImage!: boolean;
  @Prop(Boolean) readonly isRowLayoutReversed!: boolean;
  @Prop(Boolean) readonly isColumnLayoutReversed!: boolean;
  @Prop(Boolean) readonly showSignInButton!: boolean;

  @State((profile) => profile.user.loggedIn, { namespace: 'profile' })
  readonly isCurrentUserLoggedIn!: boolean;

  get header() {
    if (!this.headerText) {
      return [];
    }

    return Array.isArray(this.headerText) ? this.headerText : [this.headerText];
  }

  get body() {
    if (!this.bodyText) {
      return [];
    }

    return Array.isArray(this.bodyText) ? this.bodyText : [this.bodyText];
  }

  get isLayoutStacked() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get isImageBeforeText() {
    return (
      (this.isLayoutStacked && !this.isColumnLayoutReversed) ||
      (!this.isLayoutStacked && !this.isRowLayoutReversed)
    );
  }

  get isBackgroundImage() {
    return !this.isLayoutStacked && this.isHeroImage;
  }

  get imageContainerClass() {
    return {
      'section-image': true,
      'content-container': this.isLayoutStacked && !this.isHeroImage,
      'py-12': !this.isLayoutStacked && !this.isHeroImage,
      'hero-image': this.isHeroImage,
      'layout-reversed':
        this.isHeroImage && this.isLayoutStacked && this.isColumnLayoutReversed,
    };
  }

  get imageProps() {
    return {
      src: this.imageUrl,
      alt: this.imageAlt,
      class: {
        'd-block': true,
        'max-w-small': !this.isHeroImage && !this.imageWidth,
        'mx-auto': !this.isHeroImage,
      },
      style:
        !this.isHeroImage && this.imageWidth
          ? {
              maxWidth:
                typeof this.imageWidth === 'string'
                  ? this.imageWidth
                  : `${this.imageWidth}px`,
            }
          : undefined,
    };
  }

  goTo(route: string) {
    this.$router.push(route);
  }

  goToLoginService() {
    this.promptToLogin({
      redirectAfterLoginPath: this.$route.fullPath,
    });
  }
}
